// Font options for the text editor
import image1 from '../assets/images/suit.jpg'
export const fonts = [
    { name: "Arial", family: "Arial, sans-serif" },
    { name: "Times New Roman", family: "Times New Roman, serif" },
    { name: "Helvetica", family: "Helvetica, sans-serif" },
    { name: "Verdana", family: "Verdana, sans-serif" },
    { name: "Georgia", family: "Georgia, serif" },
    { name: "Courier New", family: "Courier New, monospace" },
    { name: "Tahoma", family: "Tahoma, sans-serif" },
    { name: "Trebuchet MS", family: "Trebuchet MS, sans-serif" },
    { name: "Impact", family: "Impact, sans-serif" },
    { name: "Comic Sans MS", family: "Comic Sans MS, cursive" },
  ]
  
  // Graphic elements that can be added to designs
  export const graphicElements = [
    {
      id: 1,
      name: "Star",
      src: "https://www.freeiconspng.com/uploads/star-icon-png-transparent-2.png",
    },
    {
      id: 2,
      name: "Heart",
      src: "https://www.freeiconspng.com/uploads/heart-png-15.png",
    },
    {
      id: 3,
      name: "Circle",
      src: "https://www.freeiconspng.com/uploads/circle-png-17.png",
    },
    {
      id: 4,
      name: "Diamond",
      src: "https://www.freeiconspng.com/uploads/diamond-png-20.png",
    },
    {
      id: 5,
      name: "Crown",
      src: "https://www.freeiconspng.com/uploads/crown-png-10.png",
    },
    {
      id: 6,
      name: "Flower",
      src: "https://www.freeiconspng.com/uploads/flower-icon-png-7.png",
    },
    {
      id: 7,
      name: "Butterfly",
      src: "https://www.freeiconspng.com/uploads/butterfly-png-21.png",
    },
    {
      id: 8,
      name: "Paw Print",
      src: "https://www.freeiconspng.com/uploads/paw-print-png-1.png",
    },
    {
      id: 9,
      name: "Music Note",
      src: "https://www.freeiconspng.com/uploads/music-note-png-10.png",
    },
  ]
  
  // Design templates
  export const designTemplates = [
    {
      id: 1,
      name: "T-Shirt",
      image:image1,
       
      template:image1,

    },
    {
      id: 2,
      name: "Hoodie",
      image:
        "https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80",
      template: "https://www.pngarts.com/files/3/Pullover-Hoodie-PNG-Image-Background.png",
    },
    {
      id: 3,
      name: "Dress",
      image:
        "https://images.unsplash.com/photo-1595777457583-95e059d581b8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1483&q=80",
      template: "https://freepngimg.com/thumb/dress/31600-6-dress-transparent-image.png",
    },
    {
      id: 4,
      name: "Pants",
      image:
        "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1497&q=80",
      template: "https://www.pngall.com/wp-content/uploads/5/Pant-PNG-Free-Image.png",
    },
  ]
  
  